import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Login } from './pages/Login/Loadable';
import { Dashboard } from './pages/Dashboard/Loadable';
import { NotFoundPage } from './pages/NotFoundPage/Loadable';
import { ForgotPassword } from './pages/ForgotPassword/Loadable';
import { PrivateRoute } from './components/PrivateRoute';
import { useAppVersionCheck } from './hooks/useAppVersionCheck';
import { FleetEmbedProvider } from './context/FleetEmbedContext';

const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '');

export function App() {
  const { t, i18n } = useTranslation();
  useAppVersionCheck();

  return (
    <FleetEmbedProvider>
      <BrowserRouter basename={routerBasename}>
        <Helmet
          titleTemplate={`%s - ${t('MainPage.titleTemplate')}`}
          defaultTitle={t('MainPage.titleTemplate')}
          htmlAttributes={{ lang: i18n.resolvedLanguage }}
        >
          <meta name="description" content={t('MainPage.description')} />
        </Helmet>

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </FleetEmbedProvider>
  );
}
